module.exports = __webpack_public_path__ + "img/match--hakari.32acf99a.png";